export default __webpack_public_path__ + "static/banner7-b6cf515ed672ed301e1abf8e6fcaf53d.png";